import { getUserPosition, type UserPosition as SdkUserPosition } from "@breakout/sdk"
import { ZERO_ADDRESS } from "@breakout/shared/constants"
import type { Maybe } from "@breakout/shared/types/market"
import { type UseQueryOptions, useQuery } from "@tanstack/react-query"
import type { Address } from "viem"
import { useBreakoutConfig } from "../../lib/providers"
import { marketKeys } from "../market/useMarket"

interface UserPositionArgs {
	marketAddress: Address
	userAddress: Address
}

// staleTime: 10s (changes with trades)
export function useUserPosition(
	args: Maybe<UserPositionArgs>,
	options?: Omit<UseQueryOptions<SdkUserPosition>, "queryKey" | "queryFn">,
) {
	const { publicClient } = useBreakoutConfig()

	return useQuery({
		queryKey: marketKeys.marketShares(
			args?.marketAddress ?? ZERO_ADDRESS,
			args?.userAddress ?? ZERO_ADDRESS,
		),
		queryFn: async () => {
			if (!args) {
				throw new Error("Market address and user address required")
			}
			return getUserPosition(publicClient, { market: args.marketAddress, user: args.userAddress })
		},
		enabled: !!args,
		staleTime: 10_000,
		...options,
	})
}
